import Dialog from '@anm/components/modals/Dialog';
import AlertBlock from '@anm/components/notification/AlertBlock';
import { FC } from 'react';

import withVideoFolder, { WithVideoFolder } from '../../../../HOCs/withVideoFolder';

type HOCs = WithVideoFolder;
export type AlreadyInsideAlertProps = {
  parentId: number;
  onClose: (v: boolean) => void;
  folderId?: number;
};

const AlreadyInsideAlert: FC<HOCs & AlreadyInsideAlertProps> = ({ folderId, parentId, findFolderInTree, onClose }) => {
  const parentFolder = parentId && findFolderInTree(parentId);
  const currentFolder = folderId && findFolderInTree(folderId);

  if (parentId && !parentFolder) {
    throw new Error(`cant find the parent folder with id: ${parentFolder}`);
  }

  if (folderId && !currentFolder) {
    throw new Error(`cant find the current folder with id: ${folderId}`);
  }

  const closeModal = () => onClose(false);

  return (
    <Dialog onModalClose={closeModal} onSubmit={closeModal}>
      <AlertBlock
        onButtonClick={closeModal}
        title="This is your current folder"
        description="Please pick a new one for your folder."
      ></AlertBlock>
    </Dialog>
  );
};
export default withVideoFolder(AlreadyInsideAlert);
